module.exports = __webpack_public_path__ + "files/1e21e261aa1501babdadc7bf4b96088c.png";